/**
 * Anonymous landing analytics — fire-and-forget; never blocks UI or throws.
 */

const SESSION_KEY = "yug360_vid";
const UTM_KEY = "yug360_utm";

function safeStorage(getter, setter) {
  try {
    return { get: getter, set: setter };
  } catch {
    return null;
  }
}

const local = safeStorage(
  () => localStorage.getItem(SESSION_KEY),
  (v) => localStorage.setItem(SESSION_KEY, v),
);
const session = safeStorage(
  () => sessionStorage.getItem(UTM_KEY),
  (v) => sessionStorage.setItem(UTM_KEY, v),
);

export function getVisitorSessionId() {
  let id = local?.get?.();
  if (!id) {
    id = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `v-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    local?.set?.(id);
  }
  return id;
}

export function captureUtmFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search || "");
  const utm = {};
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]) {
    const value = params.get(key);
    if (value) utm[key] = value.slice(0, 120);
  }
  if (Object.keys(utm).length && session?.set) {
    session.set(JSON.stringify(utm));
  }
  return getStoredUtm();
}

export function getStoredUtm() {
  try {
    const raw = session?.get?.();
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function withMarketingQuery(path) {
  const utm = getStoredUtm();
  const keys = Object.keys(utm);
  if (!keys.length) return path;
  const join = path.includes("?") ? "&" : "?";
  const qs = keys.map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utm[k])}`).join("&");
  return `${path}${join}${qs}`;
}

export function trackVisitorEvent(eventType, metadata = {}) {
  try {
    const body = {
      session_id: getVisitorSessionId(),
      event_type: eventType,
      utm: getStoredUtm(),
      metadata,
    };
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    const url = base ? `${base}/api/public/visitor-events` : "/api/public/visitor-events";
    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break the product */
  }
}
